export default {
  hero: {
    title: 'News & Articles',
    subtitle: 'Latest updates on Latvia residency, import-export and Asian Alley',
  },
  featured: 'Featured Post',
  allArticles: 'All Articles',
  categories: {
    all: 'All',
    latvia: 'Latvia Residency',
    export: 'Import-Export',
    asianAlley: 'Asian Alley',
    guide: 'Guide',
  },
  empty: {
    title: 'No articles found',
    description: 'Try selecting another category or come back later.',
  },
  readMore: 'Read More',
  minuteRead: 'min read',
  cta: {
    title: 'Need Advice on Latvia Residency?',
    description: 'Our expert team is ready to answer all your questions',
    button: 'Register Free Consultation',
  },
  detail: {
    backToList: 'Back to Articles',
    share: 'Share',
    relatedPosts: 'Related Articles',
    tableOfContents: 'Table of Contents',
  },
} as const;